import {Injectable} from "@angular/core";
import {LoginPassword} from "../../core/auth/login-password";
import {Observable} from "rxjs/Observable";
import {HttpErrorResponse} from "@angular/common/http";
import {AuthService} from "../../core/auth/auth.service";
import {LoginResponse} from "./login-response";
import {LoginService} from "./login.service";

@Injectable()
export class LoginServiceImpl extends LoginService {

  private BAD_CREDENTIALS_MESSAGE = "Usuario/Contraseña incorrect@";
  private UNAUTHORIZED_MESSAGE = "Usuario no autorizado";

  constructor(private authService: AuthService) {
    super();
  }

  signIn(loginPassword: LoginPassword): Observable<LoginResponse> {
    return this.authService.signIn(loginPassword).map(response => {
      if (this.isScopeForThisSite() && this.hasAccessRole()) {
        return new LoginResponse(true);
      } else {
        return new LoginResponse(false, this.UNAUTHORIZED_MESSAGE);
      }
    }).catch((error: HttpErrorResponse) => {
      console.log("LoginComponent#login:error", error);
      return Observable.throw(new LoginResponse(false, this.BAD_CREDENTIALS_MESSAGE));
    });
  }

  private hasAccessRole() {
    return this.authService.hasAccessRoles(["GLOTTO_ROOT", "GLOTTO_ADMIN"]);
  }

  private isScopeForThisSite() {
    return this.authService.isScopeForThisSite("LOTTO_ADMIN_PORTAL");
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/login/login.service.impl.ts